/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable producers
import { tableSchemaBase as columns } from '../producers.columns';
import { tableSchemaBase as columnsWithoutContact } from '../producersWithoutContact.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IProducersDatatableSlice {
	producersDatatableOptions: TColumnsSchema[];
	setProducersDatatableOptions: (
		_producersDatatableOptions: TColumnsSchema[]
	) => void;

	producersWithoutContactDatatableOptions: TColumnsSchema[];
	setProducersWithoutContactDatatableOptions: (
		_producersDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeProducersDatatableSlice = (
	s: any
): any => ({
	producersDatatableOptions: s.producersDatatableOptions,
	producersWithoutContactDatatableOptions:
		s.producersWithoutContactDatatableOptions,
});

const initialState = {
	producersDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
	producersWithoutContactDatatableOptions:
		columnsWithoutContact.filter(
			(item) => item.defaultVisible
		),
};

export const createProducersDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', unknown]],
	[],
	IProducersDatatableSlice
> = (set) => ({
	...initialState,
	setProducersWithoutContactDatatableOptions: (
		_producersDatatableOptions: TColumnsSchema[]
	) =>
		set({
			producersWithoutContactDatatableOptions:
				_producersDatatableOptions,
		}),
	setProducersDatatableOptions: (
		_producersDatatableOptions: TColumnsSchema[]
	) =>
		set({
			producersDatatableOptions:
				_producersDatatableOptions,
		}),
});
